module.exports = __webpack_public_path__ + "img/avatar.d25a6cc8.gif";